const vaccineBooking = {
  title: 'Termin für unsere Vor-Ort-Services buchen',
  note: 'Sie werden weitergeleitet zum Buchungsformular unseres Service-Partners',
  bookAppointment: 'Jetzt termin buchen',
  selectAppointment: 'Terminart auswählen',
}

export default vaccineBooking
